
import { combineReducers } from 'redux';
import { report } from './report/report.reducer';

export const lumen = combineReducers({
    report,
});
